import React from 'react';

import ProductResults from '../../product/components/product-results';
import ProductMap from '../../product/components/product-map';
import ProductCard from '../../product/components/product-card';
import ProductShowPlaceHolder from '../../product/components/product-show-placeholder';

class VWAProductList extends React.PureComponent {
    productItem = (product, key, enableAppPDP, className, i, placeholder) => {
        if (placeholder) {
            return <ProductShowPlaceHolder product={product} />
        }

        return (
            <ProductCard
                key={key}
                product={product}
                saleCalloutPath="violatorMsg"
                hideMktDiff={true}
            />
        );
    }

    render() {
        const {
            models
        } = this.props;

        return (
            <ProductResults className={'v2'} id='models'>
                <ProductMap
                    disableMultiContainers={true}
                    products={models}
                    productItem={this.productItem}
                    customPlaceHolder={true}
                    v2={true}
                />
            </ProductResults>
        );
    }
}

export default VWAProductList;
